var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "w-full md:w-3/4" }, [
      _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
        _vm._v("Send Agreement for Signature"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-5" }, [
        _vm._v(
          "\n            If you have determined you are not the appropriate person to sign the Collaborator Agreement, please email it to the person associated with the event who is.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-12" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.email,
              expression: "form.email",
            },
          ],
          attrs: { id: "email", type: "email", name: "email" },
          domProps: { value: _vm.form.email },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "email", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("email"),
                expression: "errors.has('email')",
              },
            ],
            staticClass: "error text-error-red text-lg",
          },
          [_vm._v(_vm._s(_vm.errors.first("email")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-12" }, [
        _c(
          "button",
          { staticClass: "button mb-12", on: { click: _vm.sendEmail } },
          [_vm._v("Send agreement for signature")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "signDate" } }, [
      _vm._v("\n                Email Address "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }